/**
 * 审核管理(广告管理 公告管理 监控管理)
 */
import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const information = {
  /**
   * 广告管理
   */
  //GET /advert/{id} 查询单个广告----ygt
  advert(id) {
    return axios.get(`${base.baseURL}advert/${id}`)
  },
  //GET /advert/approve 审核广告------ygt
  approveInfo(ids) {
    return axios.get(`${base.baseURL}advert/approve?ids=${ids}`)
  },
  // POST/advert/loadFile 媒体数据上传
  loadFile(file) {
    return axios.post(`${base.baseURL}advert/loadFile`, file)
  },
  // POST/advert/page 查询广告列表(分页)
  pageInfo(params) {
    return axios.post(`${base.baseURL}advert/page`, params)

  },
  publishInfo(params) {
    return axios.post(`${base.baseURL}advert/publish`, params)
  },
    // POST/advert/publishGroup 广告发布(设备分组)------ygt
    publishGroup_advert(params){
      return axios.post(`${base.baseURL}advert/publishGroup`,params)
    },
  // DELETE/advert/remove 删除广告
  removeInfo(ids) {
    return axios.delete(`${base.baseURL}advert/remove?ids=${ids}`)
  },
  // POST/advert/save 新增广告
  saveInfo(params) {
    return axios.post(`${base.baseURL}advert/save`, params)
  },
  // POST/advert/stop广告撤销------ygt--分组
  stopAdvert(ids){
    return axios.post(`${base.baseURL}advert/stop`,ids)
  },
  // POST/advert/stopGroup广告撤销------ygt--分组
  stopGroup(ids){
    return axios.post(`${base.baseURL}advert/stopGroup`,ids)
  },
  // POST/commandsendsecord/deviceAdvertInfo 查询广告投放记录列表(分页)------ygt
  deviceAdvertInfo(params){
    return axios.post(`${base.baseURL}commandsendsecord/deviceAdvertInfo`,params)
  },

  // POST/devicegroup/page 分页查询设备分组信息------ygt
  devicegroup(params){
    return axios.post(`${base.baseURL}devicegroup/page`,params)
  },
  /**
   * 公告管理
   */
  //GET /notice/{id} 查询单个公告------ygt
  idNotice(id) {
    return axios.get(`${base.baseURL}notice/${id}`)
  },
  //GET /notice/approve 审核公告-------ygt
  appNotice(ids){
    return axios.get(`${base.baseURL}notice/approve?ids=${ids}`)
  },
  //POST /notice/page 查询公告列表(分页)------ygt
  pageNotice(param) {
    return axios.post(`${base.baseURL}notice/page`, param)
  },
  //POST /notice/publish 公告发布------ygt
  pubNotice(param) {
    return axios.post(`${base.baseURL}notice/publish`, param)
  },
  // POST/notice/publishGroup 公告发布(设备分组)------ygt
  publishGroup(param) {
    return axios.post(`${base.baseURL}notice/publishGroup`, param)
  },
  //DELETE /notice/remove/{id} 删除公告----ygt
  removeNotice(ids) {
    return axios.delete(`${base.baseURL}notice/remove?ids=${ids}`)
  },
  //POST /notice/save 新增公告-----ygt
  saveNotice(param) {
    return axios.post(`${base.baseURL}notice/save`, param)
  },
  //POST /notice/stopNotice/{id} 公告撤销------ygt
  stopNotice(id) {
    return axios.post(`${base.baseURL}notice/stopNotice/${id}`)
  },
  // POST/commandsendsecord/deviceNoticeInfo 查询公告投放记录列表(分页)------ygt
  deviceNoticeInfo(params) {
    return axios.post(`${base.baseURL}commandsendsecord/deviceNoticeInfo`,params)
  },

  // 投放记录
  // POST/commandsendsecord/publishRecordPage售货机---广告/公告投放记录-----yzg
  publishRecordPage(params) {
    return axios.post(`${base.baseURL}commandsendsecord/publishRecordPage`,params)
  }
}
export default information;



// WEBPACK FOOTER //
// ./src/network/information.js